<template>
    <div class="content-wapper">
<!--        <h1 style="font-family: 微软雅黑, 宋体">{{detail.title}}</h1>-->
        <div v-html="detail.content" class="eidt-content"></div>
    </div>
</template>

<script>
    import {getBrowseCount} from "@/api/basedata/records";
    import {getFlwqdxalyfxTzgg} from "@/api/xwqy/fvwqdxalyfxTzgg";

    export default {
        name: "detail",
        data() {
            return {
                // 遮罩层
                loading: true,
                recid: undefined,
                type: undefined,

                detail: {
                    title: '威海市个体私营企业律师服务团工作规则',
                    content: '<p>&nbsp;&nbsp;</p>\n' +
                        '<p><strong>第一条</strong> 为帮助我市个体私营企业依法经营管理，预防和化解经营风险，更好地维护个体私营企业的合法权益，促进个体私营经济科学发展，根据《山东省个体工商户和私营企业权益保护条例》第六条规定，市个体私营企业协会在市司法局、市市场监督管理局指导下，市律师协会的支持下，成立威海市个体私营企业律师服务团（以下简称律师服务团）。</p>\n' +
                        '<p><strong>第二条</strong> 律师服务团以维护个体私营企业合法权益、促进个体私营经济科学发展为宗旨，以全市个体工商户和私营企业为服务对象，积极提供优质高效的法律服务。</p>\n' +
                        '<p><strong>第三条</strong> 律师服务团设团长1名，副团长若干名，团长、副团长人选由市个体私营企业协会、市律师协会协商确定。</p>\n' +
                        '<p><strong>第四条</strong> 律师服务团成员由市个体私营企业协会和市律师协会从威海市优秀执业律师中聘任，应具备以下条件：</p>\n' +
                        '<p>&nbsp;&nbsp;&nbsp; （一）有较强的政治意识、社会责任意识和服务意识，道德品行良好；</p>\n' +
                        '<p>&nbsp;&nbsp;&nbsp; （二）有丰富的执业经验和较强的业务能力；</p>\n' +
                        '<p>&nbsp;&nbsp;&nbsp; （三）自愿为个体私营企业提供法律服务。</p>\n' +
                        '<p><strong>第五条</strong> 律师服务团成员服务期限为4年，届满可连续聘任。</p>\n' +
                        '<p><strong>第六条</strong> 律师服务团的主要职责：</p>\n' +
                        '<p>&nbsp;&nbsp;&nbsp; （一）根据市市场监管局和市个体私营企业协会的要求，针对个体私营企业在经营过程中遇到的带有普遍性的热点、难点问题，开展专题调查研究，提出对策和建议，并为我市制定促进个体私营企业发展的政策提供依据；</p>\n' +
                        '<p>&nbsp;&nbsp;&nbsp; （二）为市个体私营企业协会决策和开展有关活动提供法律服务；</p>\n' +
                        '<p>&nbsp;&nbsp;&nbsp; （三）配合市个体私营企业协会组织开展对会员的法制教育和法律培训活动，提高个体私营企业依法管理、依法经营、依法维权的意识和水平；</p>\n' +
                        '<p>&nbsp;&nbsp;&nbsp; （四）参加市个体私营企业协会组织的维护个体私营企业合法权益的公益活动，协助市个体私营企业协会处理重大疑难投诉案件；</p>\n' +
                        '<p>&nbsp;&nbsp;&nbsp; （五）接受委托，帮助个体私营企业处理有关企业设立、劳务、合同、财税等方面的法律实务以及代理诉讼等；</p>\n' +
                        '<p>&nbsp;&nbsp;&nbsp; （六）接受委托，担任个体私营企业法律顾问，帮助企业建立法律风险防范体系，制定危机处理法律预案，提高企业防范经营风险的意识和能力；</p>\n' +
                        '<p>&nbsp;&nbsp;&nbsp; （七）接受委托，参与个体私营企业发展的决策论证，提供咨询服务和法律意见；</p>\n' +
                        '<p>&nbsp;&nbsp;&nbsp; （八）接受委托，为个体私营企业进行法律体检，提前发现、规避和化解个体私营企业经营过程中存在的法律风险；</p>\n' +
                        '<p>&nbsp;&nbsp;&nbsp; （九）律师服务团成员按月轮值为个体私营企业提供免费在线法律咨询服务；</p>\n' +
                        '<p>&nbsp;&nbsp;&nbsp; （十）其他需要履行的职责。</p>\n' +
                        '<p><strong>第七条</strong> 律师服务团应定期召开工作会议，研究确定工作计划，交流通报工作情况，协商解决有关问题。</p>\n' +
                        '<p><strong>第八条</strong> 律师服务团应定期或不定期组织律师服务团成员深入基层，为个体私营企业协会会员开展法律帮扶活动。每个律师服务团成员应切实增强责任感，根据律师服务团的安排和个体私营企业需求，每年重点帮扶对象不少于三家，参与法律培训咨询活动不少于二次。</p>\n' +
                        '<p><strong>第九条</strong>&nbsp; 律师服务团成员应每季度将工作情况和工作建议书面报送市个体私营企业协会、市律师协会。</p>\n' +
                        '<p><strong>第十条</strong> 律师服务团接受市市场监管局、市司法局的指导和监督，市个体私营企业协会、市律师协会负责对律师服务团成员的组织、联络、协调和日常管理工作，律师服务团常设机构设在市个体私营企业协会。</p>\n' +
                        '<p><strong>第十一条</strong> 市个体私营企业协会、市律师协会应及时协调解决律师服务团成员在开展法律服务工作中遇到的有关问题，不断总结经验，提高服务质量。</p>\n' +
                        '<p><strong>第十二条</strong> 律师服务团成员根据市个体私营企业协会安排开展公益性法律服务，为市个体私营企业协会会员提供法律咨询、法律知识培训为无偿服务，其他法律服务应本着有偿、优惠的原则，对处于创业阶段或遇到经济困难的个体工商户和私营企业应适当减免服务费。</p>\n' +
                        '<p><strong>第十三条</strong> 律师服务团成员应遵守以下工作纪律：</p>\n' +
                        '<p>&nbsp;&nbsp;&nbsp; （一）严格遵守国家法律、法规、政策；</p>\n' +
                        '<p>&nbsp;&nbsp;&nbsp; （二）严格保守国家秘密、商业秘密和当事人个人隐私；</p>\n' +
                        '<p>&nbsp;&nbsp;&nbsp; （三）恪守律师职业道德和执业纪律；</p>\n' +
                        '<p>&nbsp;&nbsp;&nbsp; （四）服务态度严谨、诚恳、热情；</p>\n' +
                        '<p>&nbsp;&nbsp;&nbsp; （五）服从领导，按时参加有关活动，积极开展工作。</p>\n' +
                        '<p><strong>第十四条</strong> 市个体私营企业协会、市律师协会可以根据律师服务团成员履行职责的情况和个体私营企业的评价，对工作中表现出色的成员给予奖励。市律师协会在评选优秀律师时可以将律师服务团成员的表现作为参考。</p>\n' +
                        '<p><strong>第十五条</strong> 律师服务团成员有下列情形之一的，由市个体私营企业协会、市律师协会予以解聘：</p>\n' +
                        '<p>&nbsp;&nbsp;&nbsp; （一）被依法追究刑事责任，受到行政处罚、行业处分或者有其他不适宜继续担任律师服务团成员情形的；</p>\n' +
                        '<p>&nbsp;&nbsp;&nbsp; （二）违反本规则第十三条第（一）、（二）、（三）项规定的；</p>\n' +
                        '<p>&nbsp;&nbsp;&nbsp; （三）无正当理由不履行职责，或者履行职责出现重大失误的；</p>\n' +
                        '<p>&nbsp;&nbsp;&nbsp; （四）因服务态度和质量问题被投诉且查证属实的；</p>\n' +
                        '<p>&nbsp;&nbsp;&nbsp; （五）推诿或消极对待服务对象，情节严重并造成不良影响的；</p>\n' +
                        '<p>&nbsp;&nbsp;&nbsp; （六）无正当理由未完成规定工作任务的。</p>\n' +
                        '<p><strong>第十六条</strong> 本规则由市个体私营企业协会、市律师协会负责解释。</p>\n' +
                        '<p><strong>第十七条</strong> 本规则自印发之日起施行。</p>'
                },

            }
        },
        created() {

        },
        methods: {}
    }
</script>

<style scoped>
    .content-wapper {
        margin-top: 5px;
        padding: 10px;
    }

    .navigation {
        padding: 20px 15px;
        line-height: 20px;
        height: 60px;
        background-color: #F5F5F5;
        margin-bottom: 15px;
    }

    .content {
        border: 1px solid #cccccc;
        padding: 20px 80px;
    }

    .soure {
        background-color: #f3f3f3;
        padding: 10px;
        margin: 25px 0;
    }

    .eidt-content {
        text-align: left;
    }
</style>